module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/YK4352_banner_web.834cd4cb.png";